export enum Role {

  ADMIN = 'ADMINISTRATOR',
  OPERATOR = 'OPERATOR',
  AGENT = 'AGENT'

}
